if (!customElements.get('ks-product-gallery')) {
  customElements.define('ks-product-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('.ksp-gallery-track');
      this.slides = [...this.querySelectorAll('.ksp-gallery-slide')];
      this.thumbs = [...this.querySelectorAll('[data-thumb]')];
      this.dialog = this.querySelector('dialog');
      this.index = Math.max(0, this.slides.findIndex(s => s.dataset.imageId === this.dataset.initialImage));
      this.setAttribute('data-enhanced', '');
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1));
      this.querySelector('[data-expand]').addEventListener('click', e => this.open(e.currentTarget));
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
      this.thumbs.forEach((t, i) => t.addEventListener('click', e => { e.preventDefault(); this.go(i); }));
      this.slides.forEach((s, i) => s.addEventListener('click', e => {
        e.preventDefault();
        if (this.dragged) { this.dragged = false; return; }
        this.index = i; this.update(); this.open(s);
      }));
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => {
          this.index = Math.round(this.track.scrollLeft / this.track.clientWidth);
          this.update();
        }, 100);
      }, { passive: true });
      this.track.addEventListener('keydown', e => {
        const targets = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.slides.length - 1 };
        if (e.key in targets) { e.preventDefault(); this.go(targets[e.key]); this.track.focus({ preventScroll: true }); }
      });
      this.track.addEventListener('dragstart', e => e.preventDefault());
      this.track.addEventListener('pointerdown', e => {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        this.drag = { x: e.clientX, left: this.track.scrollLeft };
        this.dragged = false;
      });
      this.track.addEventListener('pointermove', e => {
        if (!this.drag) return;
        const delta = this.drag.x - e.clientX;
        if (Math.abs(delta) > 8) {
          this.dragged = true;
          this.track.setPointerCapture(e.pointerId);
          this.track.style.scrollSnapType = 'none';
          this.track.scrollLeft = this.drag.left + delta;
        }
      });
      const stopDrag = () => {
        if (!this.drag) return;
        this.drag = null;
        this.track.style.scrollSnapType = '';
        if (this.dragged) this.go(Math.round(this.track.scrollLeft / this.track.clientWidth));
      };
      this.track.addEventListener('pointerup', stopDrag);
      this.track.addEventListener('pointercancel', stopDrag);
      this.track.addEventListener('pointerleave', e => { if (!this.track.hasPointerCapture(e.pointerId)) stopDrag(); });
      this.querySelector('[data-viewer-prev]')?.addEventListener('click', () => this.go(this.index - 1));
      this.querySelector('[data-viewer-next]')?.addEventListener('click', () => this.go(this.index + 1));
      this.dialog.addEventListener('keydown', e => {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + (e.key === 'ArrowLeft' ? -1 : 1)); }
      });
      this.dialog.addEventListener('click', e => { if (e.target === this.dialog) this.dialog.close(); });
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow;
        this.opener?.focus({ preventScroll: true });
      });
      this.observer = new ResizeObserver(() => this.go(this.index, false));
      this.observer.observe(this.track);
      this.go(this.index, false);
    }
    disconnectedCallback() { this.observer?.disconnect(); clearTimeout(this.scrollTimer); }
    go(index, smooth = true) {
      this.index = Math.max(0, Math.min(this.slides.length - 1, index));
      this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant' });
      this.update();
    }
    update() {
      this.index = Math.max(0, Math.min(this.slides.length - 1, this.index));
      this.querySelector('[data-current]').textContent = this.index + 1;
      this.slides.forEach((s, i) => { s.tabIndex = i === this.index ? 0 : -1; });
      this.thumbs.forEach((t, i) => { if (i === this.index) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      const thumb = this.thumbs[this.index];
      if (thumb) {
        const strip = thumb.parentElement;
        const left = thumb.offsetLeft - strip.offsetLeft;
        if (left < strip.scrollLeft) strip.scrollLeft = left;
        else if (left + thumb.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = left + thumb.offsetWidth - strip.clientWidth;
      }
      ['[data-prev]', '[data-viewer-prev]'].forEach(s => { const b = this.querySelector(s); if (b) b.disabled = this.index === 0; });
      ['[data-next]', '[data-viewer-next]'].forEach(s => { const b = this.querySelector(s); if (b) b.disabled = this.index === this.slides.length - 1; });
      if (this.dialog.open) this.updateViewer();
    }
    updateViewer() {
      const current = this.slides[this.index];
      const large = this.querySelector('[data-large]');
      large.src = current.href;
      large.alt = current.querySelector('img').alt;
      this.querySelector('[data-original]').href = current.href;
      this.querySelector('[data-viewer-current]').textContent = this.index + 1;
    }
    open(opener) {
      this.opener = opener;
      this.previousOverflow = document.body.style.overflow;
      this.updateViewer();
      this.dialog.showModal();
      document.body.style.overflow = 'hidden';
      this.update();
    }
  });
}
